import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { TextButton, Layout } from '@oneaudi/unified-web-components';
import { messages } from '../../../i18n/messages';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';

const getNumberOfActiveFilters = (
  authorDefinedFilters: string[],
  preselectedFilters: string[] = [],
  userSelectedFilters: string[] = [],
): number => {
  const preselectedAuthorDefinedFilters = authorDefinedFilters.filter((value) =>
    preselectedFilters.includes(value),
  );
  return preselectedAuthorDefinedFilters.length + userSelectedFilters.length;
};

export default function FiltersButton() {
  const { authorDefinedFilters, preselectedFilters, userSelectedFilters } =
    mapContext.useMapState();
  const dispatch = mapContext.useMapDispatch();

  const numberOfActiveFilters = getNumberOfActiveFilters(
    authorDefinedFilters,
    preselectedFilters,
    userSelectedFilters,
  );

  return (
    <Layout margin={['24px', '28px', '24px', '28px']}>
      <TextButton
        data-test-id="filters-button-component"
        onClick={() => dispatch({ type: ActionTypes.setIsFiltersOverlayOpen, payload: true })}
        variant="primary"
        size="md"
        iconPosition="leading"
        icon="filter"
      >{`${useI18n(messages.filter)} (${numberOfActiveFilters})`}</TextButton>
    </Layout>
  );
}
